import { render, staticRenderFns } from "./CostListItem.vue?vue&type=template&id=37125278&scoped=true&"
import script from "./CostListItem.vue?vue&type=script&lang=js&"
export * from "./CostListItem.vue?vue&type=script&lang=js&"
import style0 from "./CostListItem.vue?vue&type=style&index=0&id=37125278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37125278",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBadge,VBtn,VCol,VFadeTransition,VIcon,VRow,VSimpleCheckbox})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Ripple,Touch})
